<template>
  <div class="rule-wrap">
    <back-button />
    <div class="rule-main">
      <div class="rule-title">规则说明</div>
      <div class="rule-content">
        1.2026年山西省公众科学素质网络知识竞赛于2026年9月1日至10月26日举办，正式比赛持续56天。<br />
        2.仅限山西省内的用户参与竞赛，参赛者进入大赛主页后需授权微信登录，提交选手参赛信息用作成绩统计。<br />
        3.【竞赛模式】用户参与竞赛模式，系统将从竞赛题库中随机抽取5道题进行问答，竞赛题型全部为单选题，答对1题积1分，每题答题时间为30秒（时间结束后，未做出选择，系统自动判断对错，显示正确答案并记录成绩），完成竞赛答题后系统自动计算成绩。<br />
        每日每个账号最多可参与50次答题。完成每轮答题后，答对3题及以上可参与抽奖。<br />
        4.【挑战模式】用户参与挑战模式，系统为用户随机匹配PK对手。匹配成功后开始进行对战答题，每次根据答题正确数量和用时确定胜方。最终正确作答3题及以上，高得分且用时较短者获得胜利；若正确作答数量相同（3题及以上）则用时较短者获得胜利；胜利者可获得1次抽奖机会，并获得5分。若未达到上述条件则不得分。每日每个账号最多可参与100次挑战。<br />
        5.【邀请好友赢红包】大赛期间，邀请好友注册并完成首次答题，每邀请1人即可获得1个现金红包，单人最多可获10个。每日红包数量有限，先到先得。<br />
        6.中奖金额提现：须首先在微信内完成实名认证，否则中奖金额将无法发放至授权登录的微信账户内。<br />
        7.本次线上活动中，通过竞赛模式以及挑战模式获得的积分相加作为个人总积分，并且将总积分作为发放终奖的唯一衡量标准。相同积分下，累计答题用时较短者排名靠前。<br />
        8.活动奖励<br />
        每周奖励：每周各市竞赛成绩累计前5名可分别获得5元红包元奖励。（成绩取每周四24时前成绩，总共发8周）<br />
        个人终奖：本次网络知识竞赛总排名第1、2、3名选手将分别获得“2026年山西省公众科学素质网络知识竞赛”冠、亚、季军奖，向获奖选手颁发奖状和相应物质奖励(分别为2000元、800元、500元等额的实物产品)。往届曾获得过冠、亚、季军奖的，不再次重复获相同奖项，但可获参赛纪念品，以资鼓励。<br />
        注:实物奖品只发放给山西省当地参赛选手。<br />
        9.本活动最终解释权归山西省科学技术协会所有。<br />
        10.技术支持电话：010-63581772
      </div>
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
};
</script>
<style lang="scss" scoped>
.rule-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding: 25px 20px 20px;
  overflow: hidden;
  @include plain-bg;
  @include safe-area-bottom("20px");

  .rule-main {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    padding: 57px 22px 36px;
    font-size: 15px;
    font-weight: 400;
    line-height: 32px;
    color: $black;
    background-color: $white;
    border-radius: 8px;

    .rule-title {
      position: absolute;
      top: -18px;
      right: 0;
      left: 0;
      width: 155px;
      height: 64px;
      padding-top: 18px;
      margin-right: auto;
      margin-left: auto;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 25px;
      color: #fff;
      text-align: center;
      text-shadow: 0 2px 2px #a57afb;
      text-transform: none;
      background: url("~@/assets/img/rule-title-bg.png") no-repeat center
        center/100% 100%;
    }

    .rule-content {
      height: 100%;
      margin-top: 12px;
      overflow: auto;
      text-align: justify;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
